const PRODUCT_TYPE = {
  free: "免費",
  payment: "付費",
  fundraising: "募資",
  fund_payment: "付費（募資）",
};

const CATEGORY_COLORS = {
  課程: "#1F4E5A", // dark green
  最新: "#029C81", // green
  熱門: "#FFDB69", //yellow
  活動: "#FFA658", //light orange
  省公會: "#EA5F40", //orange,
  全聯會: "#516F71",
};
function getLabels(product) {
  let labels = product.label ? product.label.split(",") : [];
  return labels;
}

module.exports = {
  PRODUCT_TYPE,
  CATEGORY_COLORS,
  getLabels,
};
